import { VehicleGroupRow } from "services/api/calculations/vehiclegroup/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const CALCULATION_VEHICLE_GROUP_SEARCH_COLUMNS: Column[] = [
  {
    title: "",
    field: "image",
    type: ColumnTypes.custom,
    render: (row: VehicleGroupRow) => {
      return (
        <div>
          <div className="w-10 h-10 rounded-full bg-gray-200 block relative">
            <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              {row.name?.toString().charAt(0).toUpperCase()}
            </span>
          </div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.vehiclegroup.search.name",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.name}</div>
          <div className="text-xs">{row.breadcrumbs}</div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.vehiclegroup.search.parentvehiclegroupname",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.parentVehicleGroupName}</div>
        </div>
      );
    },
  },
];
